import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import '../../../node_modules/react-vis/dist/style.css';

import Header from '../../components/Header';
import ModalRegionRealTime from '../../components/modals/ModalRegion';
import ModalRegionProduct from '../../components/modals/ModalRegion';
import ModalShift from '../../components/modals/ModalShift';
import ModalTimeShifts from '../../components/modals/ModalTimeShifts';
import ModalTimeBrokers from '../../components/modals/ModalTimeBrokers';
import ModalTimeCustomersToday from '../../components/modals/ModalTimeCustomersToday';
import ModalTimeCustomersNow from '../../components/modals/ModalTimeCustomersNow';
import InputDate from '../../components/inputs/InputDate';
import ResponsiveLoading, { Loading, TableLoading } from '../../components/ResponsiveLoading';
import moment from "moment";
import 'moment/locale/pt-br';

import dash from '../../assets/images/dash.svg';
import pin from '../../assets/images/pin.svg';
import pin2 from '../../assets/images/pin2.svg';
import br from '../../assets/images/brazil.svg';
import rj from '../../assets/images/rj.svg';
import sp from '../../assets/images/sp.svg';

import logo2 from '../../assets/images/logo2.svg';
import clock from '../../assets/images/clock.svg';
import pin3 from '../../assets/images/pin3.svg';
import plusCircle from '../../assets/images/plusCircle.svg';
import user2 from '../../assets/images/user2.svg';
import smile from '../../assets/images/smile.svg';
import clock2 from '../../assets/images/clock2.svg';
import user3 from '../../assets/images/user3.svg';
import bag from '../../assets/images/bag.svg';
import star2 from '../../assets/images/star2.svg';

import api from '../../services/api';
import getUserInfo from "../../services/getUserInfo";


export const Shifts = () => {
  const origin = localStorage.getItem('origin');
  
  const [showRegionsProduct, setShowRegionsProduct] = useState(false);
  const [showRegionsRealTime, setShowRegionsRealTime] = useState(false);
  const [showShiftsRealTime, setShowShiftsRealTime] = useState(false);
  const [showShiftsProduct, setShowShiftsProduct] = useState(false);
  const [showTimeShifts, setShowTimeShifts] = useState(false);
  const [showTimeBrokers, setShowTimeBrokers] = useState(false);
  const [showTimeCustomersToday, setShowTimeCustomersToday] = useState(false);
  const [showTimeCustomersNow, setShowTimeCustomersNow] = useState(false);
  const [showBrokers, setShowBrokers] = useState(true);
  const [showManagers, setShowManagers] = useState(false);
  const [showSuper, setShowSuper] = useState(false);
  const [showImob, setShowImob] = useState(false);
  const [updateFilterRealTime, setUpdateFilterRealTime] = useState(false);
  const [shiftsRealtime, setShiftsRealtime] = useState([]);
  const [updateFilterProduct, setUpdateFilterProduct] = useState(null);
  const [shiftsProduct, setShiftsProduct] = useState([]);
  const [unidadesEstoque, setUnidadesEstoque] = useState(0);
  const [unidadesTotal, setUnidadesTotal] = useState(0);
  const [vendas, setVendas] = useState(0);
  const [distratos, setDistratos] = useState(0);
  const [corretoresDiaMedia, setCorretoresDiaMedia] = useState(0);
  const [tempoAtendimento, setTempoAtendimento] = useState(0);
  const [filterPlantoes, setFilterPlantoes] = useState({});
  const [updateFilterPlantoes, setUpdateFilterPlantoes] = useState(null);
  const [checkins, setCheckins] = useState(0);
  const [atendimentos, setAtendimentos] = useState(0);
  const [vendasPlantoes, setVendasPlantoes] = useState(0);
  const [distratosPlantoes, setDistratosPlantoes] = useState(null);
  const [corretores, setCorretores] = useState(null);
  const [gerentes, setGerentes] = useState(null);
  const [imobiliarias, setImobiliarias] = useState(null);
  const [superintendentes, setSuperintendentes] = useState(null);
  const [totalShiftsTempoReal, setTotalShiftsTempoReal] = useState(0);
  const [totalShiftsProduct, setTotalShiftsProduct] = useState(0);

  const [plantoesAtivos, setPlantoesAtivos] = useState(0);
  const [corretoresAtivos, setCorretoresAtivos] = useState(0);
  const [clientesAtendidos, setClientesAtendidos] = useState(0);
  const [clientesAtendimento, setClientesAtendimento] = useState(0);

  const [regionTempoReal, setRegionTempoReal] = useState({});
  const [regionProduct, setRegionProduct] = useState({});
  const [filterRealTime, setFilterRealTime] = useState({});
  const [filterProduct, setFilterProduct] = useState({});
  const [startDate, setStartDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [hour, setHour] = useState('0:00');

  const [loadingShifts, setLoadingShifts] = useState(true);
  const [loadingTempoRealPlantoes, setLoadingTempoRealPlantoes] = useState(true);
  const [loadingProdutosPlantoes, setLoadingProdutosPlantoes] = useState(false);
  const [loadingPlantoes, setLoadingPlantoes] = useState(true);
  const [loadingTotais, setLoadingTotais] = useState(true);
  const [loadingCorretores, setLoadingCorretores] = useState(true);
  const [loadingGerentes, setLoadingGerentes] = useState([]);
  const [loadingSuperintendentes, setLoadingSuperintendentes] = useState(true);
  const [loadingImobiliarias, setLoadingImobiliarias] = useState(true);

  const [allShifts, setAllShifts] = useState([]);
  const [userInfo, setUserInfo] = useState({});

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  let urlRegionId = urlParams.get('region_id') ?? null;
  let urlRegionNome = urlParams.get('region_nome') ?? null;
  let urlRegionSlug = urlParams.get('region_slug') ?? null;

  const [icon] = useState({
    'br': br,
    'sp': sp,
    'rj': rj
  });

  useEffect(() => {
    window.handleRegion = (id, nome, slug) => {
      let region = { id, nome, slug };
      handleRegion(region, 'product');
      handleRegion(region, 'real-time');
    };

    getUserInfo().then(user => {
      setUserInfo(user);
    });
  }, []);

  useEffect(() => {
    let date = new Date();

    setStartDate(date);
    setFinalDate(date);

    let productFilter = {
      date_start: moment(date).format('YYYY-MM-DD'),
      date_end: moment(date).format('YYYY-MM-DD'),
      regional_id: urlRegionId
    };

    let realTimeFilter = {
      regional_id: urlRegionId
    };

    let region = {
      id: urlRegionId,
      nome: urlRegionNome ?? 'Brasil',
      slug: urlRegionSlug ?? 'br'
    };

    setRegionTempoReal(region);
    setRegionProduct(region);

    setFilterPlantoes(productFilter);
    setFilterProduct(productFilter);
    setFilterRealTime(realTimeFilter);

    getAllShifts();
    getTempoRealPlantoes(realTimeFilter);
    getShifts({ regional_id: urlRegionId }, 'real-time');
  }, []);

  // useEffect(() => {
  //   getTempoRealPlantoes(filterRealTime);
  // }, [regionTempoReal, shiftsRealtime]);

  useEffect(() => {
    if(updateFilterProduct !== null && filterProduct.plantoes_ids){
      getProdutosPlantoes(filterProduct);
    }
  }, [updateFilterProduct]);

  useEffect(() => {
    if(updateFilterPlantoes !== null && filterPlantoes.plantoes_ids){
      
      getTotais(filterPlantoes);
      getCorretores(filterPlantoes);
      getGerentes(filterPlantoes);
      getSuperintendentes(filterPlantoes);
      getImobiliarias(filterPlantoes);
    }
  }, [updateFilterPlantoes]);

  const getAllShifts = async () => {
    const { data } = await api.get(`list-plantoes`);
    let toAllShifts = [];
    if (data) {
      data.regionais.map(regional => {
        regional.plantoes.map(plantao => {
          toAllShifts.push(plantao);
        });
      });
    }

    setAllShifts(toAllShifts);
  }

  const getShifts = async (filter = {}, type = "") => {
    setLoadingShifts(true);
    const { data, status } = await api.get(`list-plantoes`, {
      params: {
        regional_id: filter.regional_id
      }
    });
    let totalShifts = 0;
    let s = [];
    data.regionais.map(regional => {
      totalShifts += regional.plantoes.length;
      regional.plantoes.map(plantao => {
        s.push(plantao.id);
      });
    });

    if (type !== "product") {
      setShiftsRealtime(s);
      setTotalShiftsTempoReal(totalShifts);
    }
    

    if (typeof filter.regional_id === 'undefined' || filter.regional_id === 'null') {
      setTotalShiftsProduct(totalShifts);
    }

    setLoadingShifts(false);
  }

  const getTempoRealPlantoes = async (filters = {}) => {
    setLoadingTempoRealPlantoes(true);
    const { data, status } = await api.get(`plantoes/resumo`, {
      params: filters
    });
    if (status === 200) {
      setPlantoesAtivos(data.plantoes_ativos);
      setCorretoresAtivos(data.corretores_ativos);
      setClientesAtendidos(data.clientes_atendidos);
      setClientesAtendimento(data.clientes_em_atendimento);
      setLoadingTempoRealPlantoes(false);
    }
    setHour(moment().format('LT'));
  }
  const getProdutosPlantoes = async (filters = {}) => {
    setLoadingProdutosPlantoes(true);

    const { data, status } = await api.get(`plantoes/produtos/resumo-produtos`, {
      params: {
        plantoes_ids: filters.plantoes_ids
      }
    });
    if (status === 200) {
      setUnidadesEstoque(data.unidades_estoque);
      setUnidadesTotal(data.unidades_total);
      setVendas(data.vendas);
      setDistratos(data.distratos);
      setCorretoresDiaMedia(data.corretores_dia_media);
      setTempoAtendimento(data.tempo_atendimento_media);
      setLoadingProdutosPlantoes(false);
    }
  }

  const getTotais = async (filters = {}) => {
    setLoadingTotais(true);
    const { data, status } = await api.get(`plantoes/produtos/resumo-plantoes/total`, {
      params: filters
    });

    if (status === 200) {
      setAtendimentos(data.atendimentos);
      setCheckins(data.checkins);      
      setVendasPlantoes(data.vendas);
      setDistratosPlantoes(data.distratos);
      setLoadingTotais(false);
    }
  }

  const getCorretores = async (filters = {}) => {
    setLoadingCorretores(true);
    const { data, status } = await api.get(`plantoes/produtos/resumo-plantoes/corretores`, {
      params: filters
    });

      const ordenarPorAtendimentosCorretores = data.corretores.sort(function(a, b){
        return b.total.atendimentos - a.total.atendimentos;
      });
  
    if (status === 200) {
      setCorretores(ordenarPorAtendimentosCorretores);
      setLoadingCorretores(false);
    }
  }

  const getGerentes = async (filters = {}) => {
    setLoadingGerentes(true);
    const { data, status } = await api.get(`plantoes/produtos/resumo-plantoes/gerentes`, {
      params: filters
    });

    const ordenarPorAtendimentosGerentes = data.gerentes.sort(function(a, b){
      return b.total.atendimentos - a.total.atendimentos;
    });

    if (status === 200) {
      
      setGerentes(ordenarPorAtendimentosGerentes);
      setLoadingGerentes(false);
    }
  }

  const getSuperintendentes = async (filters = {}) => {
    setLoadingSuperintendentes(true);
    const { data, status } = await api.get(`plantoes/produtos/resumo-plantoes/superintendentes`, {
      params: filters
    });

    const ordenarPorAtendimentosSuperintendentes = data.superintendentes.sort(function(a, b){
      return b.total.atendimentos - a.total.atendimentos;
    });

    if (status === 200) {
      setSuperintendentes(ordenarPorAtendimentosSuperintendentes);
      setLoadingSuperintendentes(false);
    }
  }

  const getImobiliarias = async (filters = {}) => {
    setLoadingImobiliarias(true);
    const { data, status } = await api.get(`plantoes/produtos/resumo-plantoes/imobiliarias`, {
      params: filters
    });

    const ordenarPorAtendimentosImobiliarias = (data.imobiliarias === null) ? [] : data.imobiliarias.sort(function(a, b){
      return b.total.atendimentos - a.total.atendimentos;
    });

    if (status === 200 && data.imobiliarias !== null) {
      setImobiliarias(ordenarPorAtendimentosImobiliarias);
      setLoadingImobiliarias(false);
    }
  }

  const handleRegion = (region, typeRegion) => {
    if (typeRegion === 'real-time') {
      setRegionTempoReal(region);
      setShowRegionsRealTime(false);

      let filter = filterRealTime;
      filter.regional_id = region.id;
      delete filter.plantoes_ids;

      getShifts(filter, typeRegion);
      setFilterRealTime(filter);
      getTempoRealPlantoes(filter);
    } else {
      setRegionProduct(region);
      setShowRegionsProduct(false);
      setShiftsProduct([]);
      let filter = filterProduct;
      // filter.regional_id = region.id;
      delete filter.plantoes_ids;
      let pFilter = filterPlantoes;
      getShifts(filter, typeRegion);
      delete pFilter.plantoes_ids;
      // pFilter.regional_id = region.id;
      setFilterProduct(filter);
      setUpdateFilterProduct(!updateFilterProduct);
      setFilterPlantoes(pFilter);
      setUpdateFilterPlantoes(!updateFilterPlantoes);
    }
  }

  const handleShiftRealTime = (shifts, allShifts) => {
    setShowShiftsRealTime(false);

    const allSelected =
      shifts.length === allShifts.length &&
      allShifts.every(id => shifts.includes(id));

    const newFilter = { ...filterRealTime };
    
    setShiftsRealtime(shifts);

    if (!allSelected) {
      newFilter.plantoes_ids = shifts.join(',');
    } else {
      delete newFilter.plantoes_ids; 
    }

    setFilterRealTime(newFilter);
    getTempoRealPlantoes(newFilter);
  }
  
  const handleShiftProduct = (shifts) => {
    setShowShiftsProduct(false);
    let filter = filterProduct;
    let pFilter = filterPlantoes;
    setShiftsProduct(shifts);
    filter.plantoes_ids = shifts.join(',');
    pFilter.plantoes_ids = shifts.join(',');
    setFilterProduct(filter);
    setUpdateFilterProduct(!updateFilterProduct);
    setFilterPlantoes(pFilter);
    setUpdateFilterPlantoes(!updateFilterPlantoes);
  }

  const handleFilterRealTime = () => {
    getTempoRealPlantoes(filterRealTime);
  }

  const handleDate = (start, final) => {
    let filter = filterPlantoes;
    filter.date_start = moment(start).format('YYYY-MM-DD');
    filter.date_end = moment(final).format('YYYY-MM-DD');
    setFilterPlantoes(filter);
    let fProduct = filterProduct;
    fProduct.date_start = moment(start).format('YYYY-MM-DD');
    fProduct.date_end = moment(final).format('YYYY-MM-DD');
    setFilterProduct(fProduct);
    setUpdateFilterPlantoes(!updateFilterPlantoes);
    setStartDate(start);
    setFinalDate(final);
  }

  const handleDataBox = (type) => {
    if (type === 'manager') {
      setShowManagers(true);
      setShowBrokers(false);
      setShowSuper(false);
      setShowImob(false);
    } else if (type === 'broker') {
      setShowManagers(false);
      setShowBrokers(true);
      setShowSuper(false);
      setShowImob(false);
    } else if (type === 'super') {
      setShowManagers(false);
      setShowBrokers(false);
      setShowSuper(true);
      setShowImob(false);
    } else {
      setShowManagers(false);
      setShowBrokers(false);
      setShowSuper(false);
      setShowImob(true);

    }
  }

  return (
    <>
      {showRegionsRealTime &&
        <ModalRegionRealTime handleClose={() => setShowRegionsRealTime(false)} handleRegion={(region) => handleRegion(region, 'real-time')} />
      }
      {showRegionsProduct &&
        <ModalRegionProduct handleClose={() => setShowRegionsProduct(false)} handleRegion={(region) => handleRegion(region, 'product')} />
      }
      {showShiftsRealTime &&
        <ModalShift 
          region={regionTempoReal} 
          handleClose={() => setShowShiftsRealTime(false)} 
          handleShift={handleShiftRealTime} 
          shifts={shiftsRealtime} 
        />
      }
      {showShiftsProduct &&
        <ModalShift 
          region={regionProduct} 
          isUnique={true} 
          handleClose={() => setShowShiftsProduct(false)} 
          handleShift={handleShiftProduct} 
          shifts={shiftsProduct} 
        />
      }
      {showTimeShifts &&
        <ModalTimeShifts regionName={regionTempoReal?.nome} plantoesName={shiftsRealtime.length === totalShiftsTempoReal ? `Todos os plantões` : `${shiftsRealtime.length}  Produtos Selecionados`} plantoesAtivos={plantoesAtivos} filter={filterRealTime} handleClose={() => setShowTimeShifts(false)} />
      }
      {showTimeBrokers &&
        <ModalTimeBrokers regionName={regionTempoReal?.nome} plantoesName={shiftsRealtime.length === totalShiftsTempoReal ? `Todos os plantões` : `${shiftsRealtime.length}  Produtos Selecionados`} corretoresAtivos={corretoresAtivos} filter={filterRealTime} handleClose={() => setShowTimeBrokers(false)} />
      }
      {showTimeCustomersToday &&
        <ModalTimeCustomersToday regionName={regionTempoReal?.nome} plantoesName={shiftsRealtime.length === totalShiftsTempoReal ? `Todos os plantões` : `${shiftsRealtime.length}  Produtos Selecionados`} clientesAtendidos={clientesAtendidos} filter={filterRealTime} handleClose={() => setShowTimeCustomersToday(false)} />
      }
      {showTimeCustomersNow &&
        <ModalTimeCustomersNow regionName={regionTempoReal?.nome} plantoesName={shiftsRealtime.length === totalShiftsTempoReal ? `Todos os plantões` : `${shiftsRealtime.length}  Produtos Selecionados`} clientesAtendimento={clientesAtendimento} filter={filterRealTime} handleClose={() => setShowTimeCustomersNow(false)} />
      }
      <section id="content">
        <Header icon={<img src={pin} />} title="Plantões" />
        {/* {!loadingPlantoes && !loadingProdutosPlantoes && !loadingShifts && !loadingTempoRealPlantoes && */}
        {true &&
          <>
          <div className="pd-37">
            <div className="box light-grey">
              <div className="box-header">
                <div className="box-title">
                  <img src={clock} />
                  <div className="box-title-text">
                    <h2>Tempo real</h2>
                    <span>Última atualização: {hour}</span>
                  </div>
                </div>
                <div className="box-tools">

                  {userInfo.isMaster && origin !== 'app' &&
                  <button className="btn-filter" style={{minWidth: 180}} onClick={() => setShowRegionsRealTime(true)}>
                    {loadingTempoRealPlantoes &&
                    <Loading cWidth={120} cHeight={40}/>
                    }
                    {!loadingTempoRealPlantoes &&
                    <>
                      <img src={icon[regionTempoReal.slug] ?? br}/>
                      <span>{regionTempoReal.nome ?? 'Brasil'}</span>
                    </>
                    }
                  </button>
                  }
                  <button className="btn-filter" style={{ minWidth: 250 }} onClick={() => setShowShiftsRealTime(true)}>
                    {loadingShifts &&
                      <Loading cWidth={220} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        <img src={pin2} />
                        <span>{shiftsRealtime.length === totalShiftsTempoReal ? `Todos os plantões` : `${shiftsRealtime.length}  Produtos Selecionados`}</span>
                      </>
                    }
                  </button>
                  <button className="btn-update" onClick={handleFilterRealTime}>Atualizar</button>
                </div>
              </div>
              <div className="box-body">
                <Row>
                  <Col sm={3}>
                    <div className="box-card box-card-shifts">
                      <div className="box-card-body">
                        <div className="group-count">
                          <div className="group-count-shifts colorLightBlue">
                            {loadingTempoRealPlantoes &&
                              <Loading cWidth={100} cHeight={48} />
                            }
                            {!loadingTempoRealPlantoes &&
                              <>
                                <img src={pin3} />
                                <span className="n-count">{plantoesAtivos}</span>
                              </>
                            }
                          </div>
                          <span className="desc-count">Plantões com algum <br /> corretor</span>
                          <a href="#" onClick={() => setShowTimeShifts(true)}>
                            <img src={plusCircle} />
                            Ver mais
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className="box-card box-card-shifts">
                      <div className="box-card-body">
                        <div className="group-count">
                          <div className="group-count-shifts" id="colorGreen">
                            {loadingTempoRealPlantoes &&
                              <Loading cWidth={100} cHeight={48} />
                            }
                            {!loadingTempoRealPlantoes &&
                              <>
                                <img src={user2} />
                                <span className="n-count">{corretoresAtivos}</span>
                              </>
                            }
                          </div>
                          <span className="desc-count">Corretores<br /> nos plantões</span>
                          <a href="#" onClick={() => setShowTimeBrokers(true)}>
                            <img src={plusCircle} />
                            Ver mais
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className="box-card box-card-shifts">
                      <div className="box-card-body">
                        <div className="group-count">
                          <div className="group-count-shifts colorLightBlue">
                            {loadingTempoRealPlantoes &&
                              <Loading cWidth={100} cHeight={48} />
                            }
                            {!loadingTempoRealPlantoes &&
                              <>
                                <img src={smile} />
                                <span className="n-count">{clientesAtendidos}</span>
                              </>
                            }
                          </div>
                          <span className="desc-count">Atendimentos totais<br/> do dia</span>
                          <a href="#" onClick={() => setShowTimeCustomersToday(true)}>
                            <img src={plusCircle} />
                            Ver mais
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className="box-card box-card-shifts">
                      <div className="box-card-body">
                        <div className="group-count">
                          <div className="group-count-shifts" id="colorOrange">
                            {loadingTempoRealPlantoes &&
                              <Loading cWidth={100} cHeight={48} />
                            }
                            {!loadingTempoRealPlantoes &&
                              <>
                                <img src={clock2} />
                                <span className="n-count">{clientesAtendimento}</span>
                              </>
                            }
                          </div>
                          <span className="desc-count">Clientes sendo <br /> atendidos agora</span>
                          <a href="#" onClick={() => setShowTimeCustomersNow(true)}>
                            <img src={plusCircle} />
                            Ver mais
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="box dark-blue boxNoPadding">
              <Row>
                <Col sm={4}>
                  <div className="boxPadding boxLeft">
                    <div className="box-header box-shifts">
                      <div className="box-title">
                        <h2>Selecione um produto</h2>
                      </div>
                      <div className="box-tools">
                        {userInfo.isMaster && origin !== 'app' &&
                        <button className="btn-filter" style={{minWidth: 180}}
                                onClick={() => setShowRegionsProduct(true)}>
                          {loadingProdutosPlantoes &&
                          <Loading cWidth={220} cHeight={40}/>
                          }
                          {!loadingProdutosPlantoes &&
                          <>
                            <img src={icon[regionProduct.slug] ?? br}/>
                            <span>{regionProduct.nome ?? 'Brasil'}</span>
                          </>
                          }
                        </button>
                        }
                        <button className="btn-filter" style={{ minWidth: 250 }} onClick={() => setShowShiftsProduct(true)}>
                          {loadingProdutosPlantoes &&
                            <Loading cWidth={220} cHeight={40} />
                          }
                          {!loadingProdutosPlantoes &&
                            <>
                              <img src={pin2} />
                              {shiftsProduct.length === 0 &&
                                <span>Produto</span>
                              }
                              {shiftsProduct.length !== 0 &&
                                <span>{shiftsProduct.length === totalShiftsProduct ? `Todos os plantões` : `${allShifts.filter(s => s.id === shiftsProduct[0])[0].imovel_nome}`}</span>
                              }
                            </>
                          }
                        </button>
                      </div>
                    </div>
                    {shiftsProduct.length !== 0 &&
                      <div className="box-body">
                        <Row>
                          <Col sm={12}>
                            <div className="h-full">
                              <div className="box-card-body">
                                <table className="table-dash table-shifts">
                                  <tbody>
                                    {/* <tr>
                                      <td>Unidades em estoque</td>
                                      {loadingProdutosPlantoes &&
                                        <Loading cWidth={100} cHeight={48} bColor={`#00467f`} fColor={`#005597`} />
                                      }
                                      {!loadingProdutosPlantoes &&
                                        <td>{unidadesEstoque}</td>
                                      }
                                    </tr> */}
                                    <tr>
                                      <td>Total de unidades</td>
                                      {loadingProdutosPlantoes &&
                                        <Loading cWidth={100} cHeight={48} bColor={`#00467f`} fColor={`#005597`} />
                                      }
                                      {!loadingProdutosPlantoes &&
                                        <td>{unidadesTotal}</td>
                                      }
                                    </tr>
                                    <tr>
                                      <td>Contratos assinados</td>
                                      {loadingProdutosPlantoes &&
                                        <Loading cWidth={100} cHeight={48} bColor={`#00467f`} fColor={`#005597`} />
                                      }
                                      {!loadingProdutosPlantoes &&
                                        <td>{vendas}</td>
                                      }
                                    </tr>
                                    <tr>
                                      <td style={{ color: "#FF6542" }}>Total de Distratos</td>
                                      {loadingProdutosPlantoes &&
                                        <Loading cWidth={100} cHeight={48} bColor={`#00467f`} fColor={`#005597`} />
                                      }
                                      {!loadingProdutosPlantoes &&
                                        <td style={{ color: "#FF6542" }}>{distratos}</td>
                                      }
                                    </tr>
                                    <tr>
                                      <td>Média de corretores por dia</td>
                                      {loadingProdutosPlantoes &&
                                        <Loading cWidth={100} cHeight={48} bColor={`#00467f`} fColor={`#005597`} />
                                      }
                                      {!loadingProdutosPlantoes &&
                                        <td>{corretoresDiaMedia}</td>
                                      }
                                    </tr>
                                    <tr>
                                      <td>Tempo médio de atendimento</td>
                                      {loadingProdutosPlantoes &&
                                        <Loading cWidth={100} cHeight={48} bColor={`#00467f`} fColor={`#005597`} />
                                      }
                                      {!loadingProdutosPlantoes &&
                                        <td><p>{tempoAtendimento}</p><span>minutos</span></td>
                                      }
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    }
                  </div>
                </Col>
                <Col sm={8}>
                  <div className="box light-grey boxRight">
                    <div className="box-header">
                      <div className="box-title">

                        <img src={logo2} />
                        <div className="box-title-text">
                          {shiftsProduct.length === 0 &&
                            <h4>Dados do produto</h4>
                          }
                          {shiftsProduct.length !== 0 &&
                            <h4>{shiftsProduct.length === totalShiftsProduct ? `Todos os plantões` : `${allShifts.filter(s => s.id === shiftsProduct[0])[0].imovel_nome}`}</h4>
                          }
                        </div>
                      </div>
                      <div className="box-tools">
                        <InputDate cStartDate={startDate} cFinalDate={finalDate} handleDate={handleDate} />
                      </div>
                    </div>
                    <div className="box-body">
                      {shiftsProduct.length === 0 &&
                        <p>Selecione um produto ao lado</p>
                      }
                      {shiftsProduct.length !== 0 &&
                        <>
                          <Row>
                            <Col sm={3}>
                              <div className="box-card">
                                <div className="box-card-header center light-blue">
                                  <h3>Check-ins</h3>
                                </div>
                                <div className="box-card-body">
                                  <div className="group-count">
                                    {loadingTotais &&
                                      <Loading cWidth={100} cHeight={48} />
                                    }
                                    {!loadingTotais &&
                                      <span className="n-count">{checkins}</span>
                                    }
                                    <span className="desc-count">Check-ins no período</span>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col sm={3}>
                              <div className="box-card">
                                <div className="box-card-header center light-blue">
                                  <h3>Atendimentos</h3>
                                </div>
                                <div className="box-card-body">
                                  <div className="group-count">
                                    {loadingTotais &&
                                      <Loading cWidth={100} cHeight={48} />
                                    }
                                    {!loadingTotais &&
                                      <span className="n-count">{atendimentos}</span>
                                    }
                                    <span className="desc-count">Clientes atendidos</span>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col sm={3}>
                              <div className="box-card">
                                <div className="box-card-header center light-blue">
                                  <h3>Vendas</h3>
                                </div>
                                <div className="box-card-body">
                                  <div className="group-count">
                                    {loadingTotais &&
                                      <Loading cWidth={100} cHeight={48} />
                                    }
                                    {!loadingTotais &&
                                      <span className="n-count">{vendasPlantoes}</span>
                                    }
                                    <span className="desc-count">Contratos assinados</span>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            {distratosPlantoes !== null && 
                              <Col sm={3}>
                                <div className="box-card">
                                  <div className="box-card-header center dark-gray">
                                    <h3>Distratos</h3>
                                  </div>
                                    <div className="box-card-body" id="colorGray">
                                      <div className="group-count">
                                        {loadingTotais &&
                                          <Loading cWidth={100} cHeight={48} />
                                        }
                                        {!loadingTotais &&
                                          <span className="n-count">{distratosPlantoes}</span>
                                        }
                                        <span className="desc-count">Distratos no período</span>
                                      </div>
                                    </div>
                                </div>
                              </Col>
                            }
                          </Row>
                          <Row>
                            <Col sm={12}>
                              <div className="boxBtns">
                                <button className={`btnShifts ${showBrokers ? 'light-blue' : 'medium-blue'}`} onClick={() => handleDataBox('broker')}><img src={user3} />Corretores</button>
                                {gerentes !== null &&
                                  <button className={`btnShifts ${showManagers ? 'light-blue' : 'medium-blue'}`} onClick={() => handleDataBox('manager')}><img src={bag} />Gerentes</button>
                                }
                                {superintendentes !== null &&
                                  <button className={`btnShifts ${showSuper ? 'light-blue' : 'medium-blue'}`} onClick={() => handleDataBox('super')}><img src={star2} />Sup.</button>
                                }
                                {imobiliarias !== null &&
                                  <button className={`btnShifts ${showImob ? 'light-blue' : 'medium-blue'}`} onClick={() => handleDataBox('imob')}><img src={star2} />Imob.</button>
                                }
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={12}>
                              {showBrokers &&
                                <div className="box-card h-full">
                                  <div className="box-card-noPadding table-height">
                                    {loadingCorretores && 
                                      <TableLoading loop={20} multiply={10} cHeight={5} viewBoxHeight={170} />
                                    }
                                    {!loadingCorretores &&
                                      <table className="table-dash table-border">
                                        <thead>
                                          <tr className="light-blue">
                                            <th>Corretor</th>
                                            <th>Gerente</th>
                                            <th>Atendimentos</th>
                                            <th>Check-ins</th>
                                            <th>Assinaturas</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {corretores.map((corretor, key) => (
                                            <tr key={key}>
                                              <td>{corretor.apelido}</td>
                                              <td>{corretor.gerente ? corretor.gerente.apelido : `-`}</td>
                                              <td>{corretor.total.atendimentos}</td>
                                              <td>{corretor.total.checkins}</td>                                              
                                              <td>{corretor.total.vendas}</td>
                                            </tr>
                                          ))}

                                        </tbody>
                                      </table>
                                    }

                                  </div>
                                </div>
                              }
                              {showManagers &&
                                <div className="box-card h-full">
                                  <div className="box-card-noPadding table-height">
                                    {loadingGerentes &&
                                      <TableLoading loop={20} multiply={10} cHeight={5} viewBoxHeight={170} />
                                    }
                                    {!loadingGerentes &&
                                      <table className="table-dash table-border">
                                        <thead>
                                          <tr className="light-blue">
                                            <th>Gerente</th>
                                            <th>Superintendente</th>
                                            <th>Atendimentos</th>
                                            <th>Check-ins</th>                                            
                                            <th>Assinaturas</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {gerentes.map((gerente, key) => (
                                            <tr key={key}>
                                              <td>{gerente.apelido}</td>
                                              <td>{gerente.superintendente ? gerente.superintendente.apelido : `-`}</td>
                                              <td>{gerente.total.atendimentos}</td>
                                              <td>{gerente.total.checkins}</td>                                              
                                              <td>{gerente.total.vendas}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    }
                                  </div>
                                </div>
                              }
                              {showSuper &&
                                <div className="box-card h-full">
                                  <div className="box-card-noPadding table-height">
                                    {loadingSuperintendentes &&
                                      <TableLoading loop={20} multiply={10} cHeight={5} viewBoxHeight={170} />
                                    }
                                    {!loadingSuperintendentes &&
                                      <table className="table-dash table-border">
                                        <thead>
                                          <tr className="light-blue">
                                            <th>Superintendente</th>
                                            <th>Diretor</th>
                                            <th>Atendimentos</th>
                                            <th>Check-ins</th>                                            
                                            <th>Assinaturas</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {superintendentes.map((superintendente, key) => (
                                            <tr key={key}>
                                              <td>{superintendente.apelido}</td>
                                              <td>{superintendente.diretor ? superintendente.diretor.apelido : `-`}</td>
                                              <td>{superintendente.total.atendimentos}</td>
                                              <td>{superintendente.total.checkins}</td>                                              
                                              <td>{superintendente.total.vendas}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    }
                                  </div>
                                </div>
                              }
                              {showImob &&
                                <div className="box-card h-full">
                                  <div className="box-card-noPadding table-height">
                                    {loadingImobiliarias &&
                                      <TableLoading loop={20} multiply={10} cHeight={5} viewBoxHeight={170} />
                                    }
                                    {!loadingImobiliarias &&
                                      <table className="table-dash table-border">
                                        <thead>
                                          <tr className="light-blue">
                                            <th>Imobiliária</th>
                                            <th>Atendimentos</th>
                                            <th>Assinaturas</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {imobiliarias.map((imobiliaria, key) => (
                                            <tr key={key}>
                                              <td>{imobiliaria.nome}</td>
                                              <td>{imobiliaria.total.atendimentos}</td>
                                              <td>{imobiliaria.total.vendas}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    }
                                  </div>
                                </div>
                              }
                            </Col>
                          </Row>
                        </>
                      }
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          </>
        }
      </section>
    </>
  );

}

export default Shifts;